module.exports = __webpack_public_path__ + "img/7.5191071c.jpg";